<template>
  <div>
    <div>
      <div class="m-logbg"></div>
    </div>
    <div>
      <el-row style="background-color: #34495e;opacity:0.85;">
        <el-col :offset="1">
          <div class="dw-header-main">
            <el-row align="middle">
              <el-col>
                问卷问卷
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import DwNavMenu from "@/components/layouts/DwNavMenu.vue";

export default {
  name: "DwHeaderLogin",
  components: {
    "dw-nav-menu": DwNavMenu
  }
};
</script>

<style scoped>
.dw-header-main {
  padding: 0px;
}
.el-dropdown-link {
  color: white;
}
.m-logbg {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/DwHeaderLogin.vue